export default __webpack_public_path__ + "static/media/img-0392-serbia-full-face.c40041d9.png";